// extracted by mini-css-extract-plugin
module.exports = {"switchLabel":"CustomerModal_switchLabel__1LZv0"};